var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeditation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mind-mental-disorder--health-mind-mental-disorder-mind-think"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.472765721428573 15.814821428571431v-1.4338373571428573c0.06594482142857144 -0.5221875 0.5425140214285715 -0.8735749285714287 1.08071925 -0.8735749285714287h0.5917011000000001c0.9936482142857145 0 1.7990702142857147 -0.7876377857142859 1.7990702142857147 -1.7591213785714288V10.124684485714287c0.6719807142857143 0.025602107142857145 1.0205035714285715 -0.028072800000000002 1.4208274285714286 -0.2694964928571429 0.4012787142857143 -0.2419369285714286 0.5344812857142858 -0.7431295071428572 0.39781735714285715 -1.1842615714285716C14.560855285714288 4.790685385714287 12.68635135714286 0.8951785714285716 7.347279578571429 0.8951785714285716 3.2542844357142866 0.8951785714285716 0.8951785714285716 2.9474291571428575 0.8951785714285716 7.051918392857144c0 2.8048093071428575 0.7485483214285715 3.7461910285714293 1.6542303214285716 5.178727392857144 0.4985905928571429 0.7885926428571429 0.7091485285714286 1.7102685000000002 0.7065107357142858 2.6374347857142864 -0.0009429214285714287 0.33169350000000003 -0.0016351928571428573 0.6689967857142858 -0.0016351928571428573 0.9467408571428573",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "cognition",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.497371185714287 7.028846657142858c0.49874575714285724 -1.4713035642857146 2.071634185714286 -1.143262392857143 2.743173278571429 -0.29093303571428575 0.28816395000000006 0.3657460928571429 0.43223995714285723 0.8035361571428573 0.43223995714285723 1.313370192857143 0 0.687162942857143 -0.28261384285714286 1.2690290142857146 -0.8478654000000001 1.7456101500000003 -0.5652515571428572 0.47658113571428573 -1.2579526714285718 0.7148776714285715 -2.078115278571429 0.7148776714285715 -1.041832692857143 0 -1.922950992857143 -0.42116361428571436 -2.6433549000000003 -1.2634908428571432 -1.5840125142857147 -1.8520767214285716 -1.047430542857143 -4.5386031000000004 1.621001292857143 -5.5859739642857145",
    strokeWidth: 1.29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditation);
export default __webpack_public_path__ + "static/media/meditation.885bae7840de303dbd09ae60cdb4cd36.svg";
export { ForwardRef as ReactComponent };